import { io } from "socket.io-client";
export const socket = io(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}`,
{ 
    autoConnect: false,
    // TODO PROD
    reconnection: process.env.REACT_APP_ENV === 'dev' ? false : true,
    reconnectionAttempts: process.env.REACT_APP_ENV === 'dev' ? 0 : 30,
    reconnectionDelay: 1000, // 1s between attempt
});